/*
  Drive Snapshot v8.2 (Nutzer 12.10.2026): Umschalter Lizenzmodell / Laufzeit im Lizenzvergleich.
  Progressive Verbesserung: Ohne JavaScript bleibt der Umschalter verborgen und alle Karten stehen untereinander.
  Mit JavaScript: Umschalter einblenden, nur die gewählte Gruppe (z. B. Gewerblich | Privat) und darin nur das gewählte
  Lizenzmodell (z. B. 12 Monate | 36 Monate) zeigen. Bedienung über echte Optionsfelder (Tab, Pfeiltasten, Leertaste);
  die Statuszeile (role="status") sagt nach einem Wechsel an, was angezeigt wird. Die Vergleichstabelle bleibt unberührt.
  Markup: snippets/ds-license-panel.liquid. Mehrfach geladen (mehrere Abschnitte) = nur einmal aktiv.
*/
(function () {
  'use strict';
  if (window.DsLicenseSwitch) return;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function checked(scope) {
    return scope.querySelector('input[data-ds-switch-input]:checked') || scope.querySelector('input[data-ds-switch-input]');
  }

  function labelOf(input) {
    var text = input && input.parentNode.querySelector('.ds-switch__text');
    return text ? text.textContent.trim() : '';
  }

  function moveThumb(fieldset) {
    var track = fieldset.querySelector('.ds-switch__track');
    if (!track) return;
    var inputs = track.querySelectorAll('input[data-ds-switch-input]');
    var index = Array.prototype.indexOf.call(inputs, checked(track));
    track.style.setProperty('--ds-sw-n', String(inputs.length));
    track.style.setProperty('--ds-sw-i', String(Math.max(index, 0)));
  }

  function update(root, announce) {
    var groupSwitch = root.querySelector('[data-ds-group-switch]');
    var panels = root.querySelectorAll('[data-ds-group-panel]');
    var group = groupSwitch ? checked(groupSwitch).value : (panels[0] && panels[0].getAttribute('data-ds-group-panel'));
    var modelSwitch = null;
    each(root.querySelectorAll('[data-ds-model-switch]'), function (fs) {
      var active = fs.getAttribute('data-ds-model-switch') === group;
      fs.hidden = !active;
      if (active) modelSwitch = fs;
    });
    var model = modelSwitch ? checked(modelSwitch).value : null;
    each(panels, function (panel) {
      var active = panel.getAttribute('data-ds-group-panel') === group;
      panel.hidden = !active;
      each(panel.querySelectorAll('[data-ds-model]'), function (item) {
        item.hidden = active && model !== null && item.getAttribute('data-ds-model') !== model;
      });
    });
    each(root.querySelectorAll('.ds-switch'), moveThumb);

    var status = root.querySelector('[data-ds-switch-status]');
    if (status && announce) {
      var parts = [];
      if (groupSwitch) parts.push(labelOf(checked(groupSwitch)));
      if (modelSwitch) parts.push(labelOf(checked(modelSwitch)));
      var template = status.getAttribute('data-ds-status-text') || '%s';
      status.textContent = template.replace('%s', parts.join(', '));
    }
  }

  function select(root, group, model) {
    var g = root.querySelector('input[data-ds-switch-input="group"][value="' + group + '"]');
    if (g) g.checked = true;
    var fs = root.querySelector('[data-ds-model-switch="' + group + '"]');
    var m = fs && model ? fs.querySelector('input[value="' + model + '"]') : null;
    if (m) m.checked = true;
    update(root, false);
  }

  function setup(root) {
    if (!root || root.hasAttribute('data-ds-ready')) return;
    var controls = root.querySelector('[data-ds-switch-controls]');
    if (!controls) return;
    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[data-ds-switch-input]')) update(root, true);
    });
    controls.hidden = false;
    root.setAttribute('data-ds-ready', '');
    update(root, false);
  }

  function init(scope) {
    var base = scope || document;
    if (base.matches && base.matches('[data-ds-license-switch]')) setup(base);
    each(base.querySelectorAll('[data-ds-license-switch]'), setup);
  }

  window.DsLicenseSwitch = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme-Editor: neu geladene Abschnitte einrichten; ein gewählter Block „Lizenzmodell“ wird sichtbar geschaltet.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest ? event.target.closest('[data-ds-model]') : null;
    var panel = item ? item.closest('[data-ds-group-panel]') : null;
    var root = panel ? panel.closest('[data-ds-license-switch]') : null;
    if (root) select(root, panel.getAttribute('data-ds-group-panel'), item.getAttribute('data-ds-model'));
  });
})();
